import { U as Url } from './url.min.js';

/**
 * **Roiback**
 *
 * This BS has **a lot of legacy code**.
 * Make as little changes as possible.
 *
 * Official: www.roiback.com
 *
 * Example: <a href="www.taorogarden.com/bookcore/availability/taorogarden/2019-10-10/2019-10-15" target="_blank">TaoroGarden</a>
 *
 * @exports bs_8
 * @category engines
 */
function factory({ window, document, navigator, thn, }) {
    const engine = {};
    let $;
    const dataLayer = window.dataLayer;
    const homePage = thn.data.pageType !== 'booking_system_page';
    const theFivesHotelsUsers = [1035320, 1035571];
    const isPalladiumPropertyUsingLoyaltyRates = [1032264].includes(thn.data.accountUserId)
        && ![1016729, 1016544].includes(thn.data.propertyId); // 1016729 , 1016544 are the properties that don't use loyalty rates
    const isAmResortPropertyUsingLoyaltyRates = [1033870, 1045376].includes(thn.data.accountUserId)
        && ![1030202, 1030122, 1014897, 1030200, 1054432].includes(thn.data.propertyId); // 1030202, 1030122, 1014897, 1030200 are the properties that don't use loyalty rates
    const isSirenisPropertyUsingLoyaltyRates = [1011853, 1011855, 1011856, 1025190, 1055332, 1028444, 1028445, 1047387].includes(thn.data.propertyId);
    const isGlobalesPropertyUsingLoyaltyRates = [1036111, 1036098, 1036116, 1036100, 1048139, 1017440, 1036096, 1048147, 1048142, 1048146, 1048156, 1048154, 1048137, 1048133, 1048149, 1048148].includes(thn.data.propertyId);
    const isPalladiumOnlyYouUsingLoyaltyRates = [1034454, 1034493].includes(thn.data.accountUserId)
        && ![1033691].includes(thn.data.propertyId); // 1033691 don't use loyalty rates
    const isHyattInclusiveCollectionPropertyUsingLoyaltyRates = [1052933, 1052934].includes(thn.data.propertyId); // For the moment only want to activate for these properties to test (12/9/24)
    // Hotels which use loyalty price (the locked one)
    // Invisa Hoteles, Soho Hoteles, Holiday World, Ostar Group, Blau, Blue , Villagroup and Shambhala Apartments, Cabot Hotels, BF Hotels, Sunotel Hotels, Lv8 Resort Hotel, Vincci hotels, Marina d'Or, MÍA Hotels, The Fives, TRH Hotels, Reverence Hotels, The Sakala Resort Bali, Skyview Hotels, Tafer Hotels
    const isUserUsingLoyaltyRates = [1035966, 1041802, 1043388, 1044384, 1032648, 1036537, 1036580, 1041454, 1034719, 1032232, 1035453, 1032690, 1037504, 1036556, 1032980, 1033469, 1042930, 1033088, 1034463, 1034325, 1034331, 1036687, 1036508, 1036650, 1032346, 1032054, 1036657, 1042862, 1033594, 1032858, 1039868, 1040097, 1043865, 1032187, 1043271, 1033363, 1045172, 1035320, 1035571, 1042040, 1032607, 1021868, 1046167, 1034175, 1034293, 1041762, 1032353, 1032630, 1033436]
        .includes(thn.data.accountUserId) || isAmResortPropertyUsingLoyaltyRates || isSirenisPropertyUsingLoyaltyRates || isPalladiumPropertyUsingLoyaltyRates || isPalladiumOnlyYouUsingLoyaltyRates || isHyattInclusiveCollectionPropertyUsingLoyaltyRates || isGlobalesPropertyUsingLoyaltyRates;
    let foundSeparator = false;
    const isAlternativeRate = (rateEl) => {
        const siblingRateEl = rateEl?.previousSibling;
        if (typeof siblingRateEl === 'object' && siblingRateEl !== null && siblingRateEl instanceof Element) {
            const room = siblingRateEl.closest('.habitacion');
            return room?.previousSibling?.classList?.contains('roi-room__separator');
        }
        return false;
    };
    let dateFormat;
    engine._getDateFormat = function getDateFormat() {
        if (dateFormat) {
            return dateFormat;
        }
        // Force formats in specific properties/users
        // DD-MM-YYYY
        if ([1034175].includes(thn.data.accountUserId)) {
            dateFormat = 'DD-MM-YYYY';
            return dateFormat;
        }
        const datalayerDateBegin = thn.dataLayerHelper.get('checkinDate');
        const domDateBegin = document.querySelector('.dates-select__checkin')?.textContent;
        const datalayerDateEnd = thn.dataLayerHelper.get('checkoutDate');
        const domDateEnd = document.querySelector('.dates-select__checkout')?.textContent;
        if (datalayerDateBegin && domDateBegin
            && datalayerDateEnd && domDateEnd) {
            if (datalayerDateBegin === domDateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$1-$2')
                && datalayerDateEnd === domDateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$1-$2')) {
                dateFormat = 'MM-DD-YYYY';
            }
            else if (datalayerDateEnd === domDateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1')
                && datalayerDateEnd === domDateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3-$2-$1')) {
                dateFormat = 'DD-MM-YYYY';
            }
        }
        return dateFormat;
    };
    const roibackRefresh = thn.debounce(() => {
        thn.pageCheck();
        if (thn.data.pageName === 'Rooms and Rates') {
            // For palladium sometimes the loyalty prices are not ready
            const isPalladium = [1032264].includes(thn.data.accountUserId);
            if (isPalladium) {
                thn.widgets.price.update();
            }
            else {
                thn.widgets.price.refresh();
            }
        }
    }, 800);
    /**
       * @memberOf module:bs_8
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        if (thn.data.propertyId === 1011395 && homePage) {
            const undelegate = thn.delegate('click', '.switcher .option a', ({ target }) => {
                thn.data.selectedLang = target.title;
                thn.languageCheck();
            });
            thn.shutdown(undelegate);
        }
        if (thn.data.accountUserId === 1032664 && homePage) {
            const undelegate = thn.delegate('click', '[name="idioma"]', ({ target }) => {
                thn.data.selectedLang = target.value;
                thn.languageCheck();
            });
            thn.shutdown(undelegate);
        }
        const langContainer = document.documentElement;
        if (theFivesHotelsUsers.includes(thn.data.accountUserId) && homePage) {
            const refreshLang = thn.debounce(thn.languageCheck, 150);
            thn.observeDom(langContainer, refreshLang, {
                attributes: true,
            });
            thn.shutdown(() => {
                refreshLang.cancel();
                thn.stopObserveDom(langContainer, refreshLang);
            });
        }
        const container = document.querySelector('#app-container');
        if (container) {
            thn.roibackRefreshObserver = function paradoresObserver(mutations) {
                const validMutationsRefresh = [...mutations].map((mutation) => mutation.type === 'childList' && (mutation?.target?.id?.match(/app-container/) || mutation?.target?.className?.match(/MobileAvailability/) || mutation?.target?.id?.match(/eighty_hotel_price_check_widget/)))
                    .filter((mapResult) => !thn.empty(mapResult)); // mutation of R&R;
                if (!thn.empty(validMutationsRefresh)) {
                    roibackRefresh();
                }
            };
            thn.observeDom(container, thn.roibackRefreshObserver, {
                childList: true,
                subTree: true,
                attributes: true,
            });
            thn.shutdown(() => {
                roibackRefresh.cancel();
                thn.stopObserveDom(container, thn.roibackRefreshObserver);
                delete thn.roibackRefreshObserver;
            });
        }
        const debouncedRefresh = thn.debounce(thn.widgets.price.refresh, 1000);
        const refreshPrice = ({ message }) => {
            if (message.event === 'pageIsLoadedAndInteract' && thn.widgets.price.isTargetPage()) {
                debouncedRefresh();
            }
        };
        thn.bus.on('dataLayer:push', refreshPrice);
        thn.shutdown(() => {
            thn.bus.detach('dataLayer:push', refreshPrice);
        });
    };
    const isNotFullyLoaded = () => {
        const lockedElement = document.querySelector('.fn-roi-boards-locked-price:not(.roi-boards-locked-price--hide), [data-testid=fn-board-locked-price]:not(.roi-boards-locked-price--hide)');
        const noAvailability = document.querySelector('.no_dispo_titulo');
        const pricesOldVersion = document.querySelectorAll('.prices,.roi-boards__block--total-price');
        const pricesNewVersion = document.querySelectorAll('div[class*=RateContentWrapper] section div[class*=pensiones_box_item] div[class*=TotalPricesContainer]');
        if (isUserUsingLoyaltyRates && !thn.isVisible(lockedElement) && !engine.isUserLogged() && !noAvailability && (thn.empty(pricesOldVersion) && thn.empty(pricesNewVersion))) {
            thn.widgets.price.logger.debug('The loyalty prices have not fully loaded.');
            return true;
        }
        return false;
    };
    const containerShopCart = document.querySelector('#roi-shopping-cart');
    if (containerShopCart) {
        let refreshPageByShopCart = thn.debounce(thn.pageCheck, 500);
        thn.observeDom(containerShopCart, refreshPageByShopCart, {
            childList: true,
            subTree: true,
            attributes: true,
        });
        thn.shutdown(() => {
            refreshPageByShopCart.cancel();
            thn.stopObserveDom(containerShopCart, refreshPageByShopCart);
            refreshPageByShopCart = null;
        });
    }
    /**
       * All language conditions are checked once the DOM is ready.
       *
       * @memberOf module:bs_8
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            thn.domReady().then(function () {
                let subdomain;
                let localized;
                let aux;
                $ = window.jQuery;
                const lang = {
                    español: 'es',
                    Spanish: 'es',
                    français: 'fr',
                    French: 'fr',
                    deutsch: 'de',
                    english: 'en',
                    English: 'en',
                    Italian: 'it',
                    Portuguese: 'pt',
                    EN: 'en',
                    'Tiếng Việt': 'vi',
                };
                const host = window.location.host;
                if (thn.data.accountUserId === 1032234) {
                    if (host.match(/^sambavallarta/)) {
                        if (host.match(/\.com/)) {
                            resolve('en');
                            return;
                        }
                        resolve('es');
                    }
                    if (host.match(/hotelesemporio.com|hotelesemporio-mx.bookings.la/)) {
                        resolve('es');
                        return;
                    }
                }
                if (thn.data.accountUserId === 1039915) {
                    const isBookingEngine = window.location.pathname?.includes('bookcore');
                    // in mobile version BE this selector doesn't exist but we can get language from BE html in desktop and mobile versions
                    const langEl = document.querySelector('.current-lang, [class*=language-item-active]')?.textContent.trim();
                    const language = isBookingEngine ? ctx.getHtmlLang() : lang[langEl] || 'vi';
                    if (language && ctx.langs.test(language)) {
                        resolve(language);
                        return;
                    }
                }
                if (thn.data.propertyId === 1014081 || theFivesHotelsUsers.includes(thn.data.accountUserId)) {
                    const language = ctx.getHtmlLang();
                    if (language && ctx.langs.test(language)) {
                        resolve(language);
                        return;
                    }
                }
                if (thn.data.accountUserId === 1032664) {
                    aux = (document.getElementsByTagName('html')[0].getAttribute('lang') || '').substr(0, 2).toLowerCase();
                    if (aux.length && aux === 'pr') {
                        resolve('pt');
                    }
                }
                /*
                            For this property, use default DOM lang read first as it may load with different
                            dropdown lang value than the one shown. If the user changes the language however,
                            use the previously clicked lang element's value, because the DOM value won't change.
                        */
                // New mobile version
                const availabilityUrl = document.querySelector('[data-no-availability-url]');
                if (availabilityUrl) {
                    const urlLang = (availabilityUrl.getAttribute('data-no-availability-url') || '').match(/lang=\w{2}/);
                    aux = urlLang && (urlLang[0] || '').replace('lang=', '');
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                if (thn.data.accountUserId === 1036342) {
                    const langEl = document.querySelector('#language');
                    aux = langEl && (langEl.value || '').slice(0, 2);
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                aux = (window.location.pathname.match(ctx.urlRe) || [])[1];
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = window.location.search.match(/lang=(\w{2})/);
                if (thn.data.accountUserId === 1032166) {
                    aux = aux && aux.length > 1 && aux[1];
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                    }
                    else {
                        resolve('es');
                    }
                    return;
                }
                aux = thn.data.propertyId === 1011395 && lang[thn.data.selectedLang];
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = document.querySelector('li.wrapp_idiomas.dropdown button span.f16');
                if ([1014650].includes(thn.data.propertyId) && aux) {
                    aux = aux.textContent.trim().toLowerCase();
                    resolve(lang[aux]);
                    return;
                }
                aux = dataLayer && thn.arrayGet(dataLayer, 'transactionLanguage');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                if (window.location.pathname.match(/\/m\d?\//i) // standard mobile version
                    || (document.querySelector && document.querySelector('[data-reactroot]'))) { // React mobile version
                    subdomain = window.location.hostname.substr(0, window.location.hostname.indexOf('.'));
                    if (subdomain === 'www') {
                        localized = document.querySelector('[data-locale]');
                        if (localized) {
                            aux = localized.getAttribute('data-locale');
                        }
                        else {
                            aux = 'es';
                        }
                    }
                    else if (subdomain.length === 2) {
                        aux = subdomain;
                    }
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                aux = document.querySelector && document.querySelector('meta[name=siteLanguage]');
                aux = aux && aux.content;
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                // 1011979 krystal-cancun.com
                aux = document.querySelector('a.dropdown-toggle') || document.querySelector('td.idioma select');
                if (aux && [1032353].includes(thn.data.accountUserId)) {
                    if (window.location.pathname.match(/\/m\d?\//i)) {
                        aux = aux.value;
                    }
                    else {
                        aux = aux.textContent.trim();
                    }
                    resolve(aux);
                    return;
                }
                // City Flats Bogota (p1013824)
                aux = thn.data.propertyId === 1013824 && ((document.querySelector('header > ul:nth-child(5) > li.activo a') || {}).textContent || '').trim();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = (document.getElementsByTagName('head')[0].getAttribute('lang') || '').substr(0, 2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = (document.documentElement.lang || '').substr(0, 2);
                // Mobile version of hotel Imperial Laguna
                if (thn.data.propertyId === 1011279 && navigator.userAgent.match(/mobile/i)) {
                    aux = document.querySelector('#root').getAttribute('data-no-availability-url').match(/lang=(\w{2})/)[1];
                    if (aux.length && aux) {
                        resolve(aux);
                        return;
                    }
                }
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                // Example for property 1013116
                if ($ && $('.test.hidden').length) {
                    aux = $('.test.hidden').text().trim().split(/\s+/);
                    if (aux[1].length) {
                        resolve(aux[1]);
                        return;
                    }
                }
                aux = (document.getElementsByTagName('body')[0].getAttribute('class') || '').split(/\s+/).filter(function (name) {
                    return ctx.langs.test(name);
                });
                // Krystal hotels, BH Mallorca
                if (aux.length && [1032353, 1031991].includes(thn.data.accountUserId)) {
                    resolve(aux[0]);
                    return;
                }
                if ([1011714, 1013824].includes(thn.data.propertyId)) {
                    resolve('no_languge'); // use default
                    return;
                }
                if (thn.data.accountUserId === 1032171 && $) {
                    const langSelector = $('.custom .dropdown');
                    if (langSelector.length) {
                        if (langSelector.find('.current').html().trim() === 'Indonesia') {
                            resolve('id');
                        }
                        else {
                            resolve('en');
                        }
                    }
                    else {
                        resolve('en');
                    }
                    return;
                }
                aux = document.getElementById('list_idiomas');
                aux = aux && aux.getElementsByClassName('flag');
                aux = aux && aux.length && (aux[0].title || '');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = document.getElementsByClassName('lang');
                aux = aux && aux.length && aux[0].getElementsByClassName('flag');
                aux = aux && aux.length && (aux[0].className || '').substr(-2, 2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('.idioma.dropdown .flag:visible');
                aux = aux && aux.length && (aux.attr('class') || '').substr(-2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('td[class=idioma] select');
                aux = aux && aux.length && (aux.val() || '');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('.idioma a.dropdown-toggle');
                aux = aux && aux.length && (aux.attr('href') || '').substr(-2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('.idioma .btn img');
                aux = aux && aux.length && (aux.attr('class') || '').substr(-2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('.header_home_inner_top_right_idioma a.dropdown-toggle');
                aux = aux && aux.length && (aux.attr('href') || '').substr(-2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = document.getElementsByClassName('language');
                if (!aux.length) {
                    aux = document.getElementsByClassName('lenguaje');
                }
                aux = aux.length && aux[0].getElementsByTagName('img');
                aux = aux.length && (aux[0].className || '').substr(-2, 2);
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = window.location.search.indexOf('lang');
                if (aux && aux > 0) {
                    // Get the two ISO chars
                    aux = window.location.search.substr(aux + 5, 2);
                    if (aux && ctx.langs.test(aux)) {
                        resolve(aux);
                        return;
                    }
                }
                aux = $ && $('.flag');
                aux = aux && aux.length && (aux.attr('class') || '')
                    .replace(/.*flag[ -](\w)/g, '$1');
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                thn.logger.debug('6');
                aux = $ && $('header .activo a');
                aux = aux && aux.length && aux.eq(0).text().trim();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                /*
                        * Cabo / Vallarta - Villa del Palmar
                        * Return the opposite value, as they only
                        * have 2 options (EN / ES) and when one is
                        * shown means that the other is active.
                        */
                aux = document.getElementsByClassName('fa fa-globe');
                if (aux && aux.length > 1) {
                    aux = aux[1].nextSibling.textContent.trim();
                    if (aux === 'EN') {
                        resolve('es');
                        return;
                    }
                    if (aux === 'ES') {
                        resolve('en');
                        return;
                    }
                }
                aux = $ && $('.langSel').length && $('.langSel').text().toLowerCase();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                aux = $ && $('#qtranslate-chooser>li.active').length && $('#qtranslate-chooser>li.active').text().toLowerCase();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * Forbid execution on:
       * - hoteles-costablanca.com
       * - Palladium Group in "agency mode"
       * - When the param 'orig_alternativo' exists and has a value. (Roc Hotels)
       *
       * @memberOf module:bs_8
       * @see {@link allowed_location}
       *
       * @param {object} ctx - The context object.
       */
    engine.allowedLocation = function allowedLocation() {
        let isAllowedLocation = true;
        // Palladium group
        // old modoagencias as fallback - though they seem to use datalayer properties now for callcenter and agency modes
        if (thn.data.accountUserId === 1032264 && (document.getElementById('modoagencias') !== null || ((thn.dataLayerHelper.get('userType') === 'Callcenter' || thn.dataLayerHelper.get('userType') === 'Agency') && thn.dataLayerHelper.get('loginStatus') === 'yes'))) {
            isAllowedLocation = false;
        }
        // Roc Hotels
        if (thn.data.accountUserId === 1033635 && window.location.search.match(/\borig_alternativo=[^&]+/)) {
            isAllowedLocation = false;
        }
        // Holiday World
        if (thn.data.accountUserId === 1036580 && thn.dataLayerHelper.get('userType') === 'Agency') {
            isAllowedLocation = false;
        }
        return isAllowedLocation;
    };
    /**
       * @memberOf module:bs_8
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // Dictionary for AMResorts to detect the language
        const langDictionary = {
            es: 'reservas',
            en: 'bookings',
            fr: 'reservations',
            bg: 'rezervatsiya',
            de: 'reservierungen',
            ro: 'rezervare',
            pt: 'reserva',
            ru: 'bronirovaniye',
            it: 'prenotazioni',
        };
        // Properties that don't need to modify the hostname sometimes they are microsites
        const propertiesNotModifiedHost = [1052372, 1055366, 1055378, 1055367, 1055368, 1055370, 1055371, 1055369, 1159291];
        /* URL formatting */
        const url = new Url(ctx.baseUrl);
        let validUrl = false;
        // case 1: convert the generic booking engine url to a GET request compatible one
        if (url.decode(url.path).match(new RegExp('/bookcore/availability/(rooms/)?[^/]+/?$', 'i'))) {
            // example: https://reservas.blesscollectionhotels.com/bookcore/availability/rooms/bless/?lang=es&adults=2&rrc=1&children-ages=4&children=1&cp=test
            // outcome: https://reservas.blesscollectionhotels.com/bookcore/availability/bless/2020-10-01/2020-10-02?lang=es&adults=2&rrc=1&children-ages=4&ninos=1&cp=test
            const newPath = url.path.split('/'); // ["", "bookcore", "availability", "rooms", "hotel_name", ""]
            // get rid of the last '/' to avoid .../hotel_name//[date_begin]/...
            // can vary if the URL was called with '/' at the end of the pathname, or not.
            if (newPath[newPath.length - 1] === '') {
                newPath.pop();
            }
            if ([1040097, 1040029, 1046024, 1034493].includes(thn.data.accountUserId)) {
                newPath[1] = '[language]'; // to modify the first parameter (the language) of the URL
            }
            if ([1033870, 1045376, 1032264, 1040542].includes(thn.data.accountUserId) && !propertiesNotModifiedHost.includes(thn.data.propertyId)) {
                const newHost = url.host.split('.');
                newHost[0] = langDictionary[thn.data.language]; // to modify the hostname of the URL and thus be able to change to the correct language
                url.host = newHost.join('.');
            }
            newPath.splice(newPath.indexOf('rooms'), 1); // if /rooms/ is present, the URL will redirect to a no-availability page
            newPath.push('[date_begin]', '[date_end]');
            url.path = newPath.join('/'); // /bookcore/availability/bless/[date_begin]]/[date_end]
            validUrl = true;
            // case 2: the url is already a GET request compatible one
        }
        else if (url.decode(url.path).match(new RegExp('/bookcore/availability/[^/]+/(\\[date_begin\\]|[\\d-]{10})/(\\[date_end\\]|[\\d-]{10})/?$', 'i'))) {
            validUrl = true;
        }
        else {
            // invalid
            ctx.newUrl = '';
        }
        /* Data formatting */
        if (!validUrl
            || (thn.empty(ctx.newData.dateBegin) || thn.empty(ctx.newData.dateEnd))) {
            // invalid
            ctx.newUrl = '';
        }
        else if (validUrl && ctx.newData.dateBegin && ctx.newData.dateEnd) {
            ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.newData.dateEnd.replace(/\//g, '-');
            // Some hotels (react version) prefer the value from these variables to the ones generated for the pathname
            // Make sure we always make the request with dates in the pathname
            delete url.query.checkin;
            delete url.query.checkout;
            // Delete promocode parameter if it exists: "cp", "cp_oculto", "codpromo", "code", "promo"
            delete url.query.cp;
            delete url.query.cp_oculto;
            delete url.query.codpromo;
            delete url.query.code;
            delete url.query.promo;
            if (!url.query.adults && ctx.newData.adults) {
                url.query.adults = ctx.newData.adults;
            }
            if (!url.query.children && ctx.newData.children) {
                url.query.children = ctx.newData.children;
            }
            if (!url.query.lang && ctx.newData.lang) {
                url.query.lang = ctx.newData.lang;
            }
            if (!url.query['children-ages']
                && ctx.newData.children
                && typeof ctx.newData.roomsDispo === 'object') {
                let childrenAges;
                ctx.newData.roomsDispo.forEach((el) => {
                    childrenAges = el.childrenAges.join(',');
                });
                url.query['children-ages'] = childrenAges;
            }
            // export into ctx.new_url
            ctx.newUrl = url.decode(url.toString());
        }
        return ctx;
    };
    /**
       * Invalidates the promocode if under ".alert" presence.
       *
       * @memberOf module:bs_8
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const invalidPromo = document.querySelector('#bookcore_msg.alert')?.textContent?.includes(ctx.promocode);
        if (ctx.promocode && invalidPromo) {
            // Invalid promocode
            ctx.promocode = '';
        }
        if (thn.data.accountUserId === 1032353 && !invalidPromo) {
            const promoCode = thn.parseUrlParameter('cp');
            ctx.promocode = promoCode || '';
        }
        return ctx.promocode;
    };
    /**
       * @memberOf module:bs_8
       * @see {@link is_user_logged}
       *
       * @param {object} ctx - The context object.
       */
    engine.isUserLogged = function isUserLogged(ctx) {
        const isLogged = window.dataLayer && (thn.dataLayerHelper.get('userType') === 'Registered' || thn.dataLayerHelper.get('loginStatus')?.toLowerCase() === 'yes');
        return isLogged;
    };
    let validGuestsGroup;
    let canGetData = true;
    const modifiedOccupancyFlag = (event) => {
        // In case of not using this selector (desktop version), we cannot be more specific. We will assume that a change has been made.
        if (!event.currentTarget.classList.contains('roi-btn--occupancyn')) {
            canGetData = false;
            return;
        }
        const changedOccupancyModal = event.currentTarget.closest('.roi-modal__content');
        const adults = thn.parseNumber(changedOccupancyModal?.querySelector('select[name=adultos]')?.value);
        const childs = thn.parseNumber(changedOccupancyModal?.querySelector('select[name=ninos]')?.value);
        const infants = thn.parseNumber(changedOccupancyModal?.querySelector('select[name=bebes]')?.value);
        const actualOccupancy = validGuestsGroup?.split('-').map((el) => thn.parseNumber(el));
        if (!(actualOccupancy[0] === adults && actualOccupancy[1] === childs && actualOccupancy[2] === infants)) {
            canGetData = false;
        }
    };
    /**
       * Listen to some click/change events only on mobile React version.
       *
       * @memberOf module:bs_8
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const reactVersion = !!(document.querySelector && document.querySelector('.container-dispo [data-reactroot]'));
        $ = window.jQuery;
        if (!reactVersion && $) {
            // palladium doesn't want the PW to hide when a room is added
            if (thn.data.accountUserId !== 1032264) {
                $(document).on('click', '.btn-add-room', function roibackRemove() {
                    ctx.widget.remove(false);
                });
            }
            const occupancyListenerArgs = ['click', roibackRefresh];
            // Event listener on guests dropdown for mobile version 'Backhotel Mobile by Roiback'
            // Example property: 1011279 - https://en.hotelimperiallaguna.com/m/
            if (document.querySelector('.byroiback')) {
                if (document.querySelector('.byroiback').innerText === 'Backhotel Mobile by Roiback') {
                    const guestsSelector = document.querySelector('.ocupacion').querySelector('select');
                    if (guestsSelector) {
                        guestsSelector.removeEventListener(...occupancyListenerArgs);
                        guestsSelector.addEventListener(...occupancyListenerArgs);
                    }
                }
            }
            // Event listener on occupancy change on SPA version
            if (document.querySelectorAll('.roi-btn--occupancy').length) {
                [...document.querySelectorAll('.roi-btn--occupancy')].forEach((el) => {
                    el.removeEventListener(...occupancyListenerArgs);
                    el.addEventListener(...occupancyListenerArgs);
                });
            }
            const currencyListenersArgs = ['change', '#monedas, #currency, .currency-select select, .fn-currency-select', roibackRefresh];
            $(document).off(...currencyListenersArgs);
            $(document).on(...currencyListenersArgs);
        }
        if ($) {
            const modifyListenersArgs = ['click', 'button.roi-btn--occupancy, button.occupancy-selector-popup__save-button, button.fn-rate-tab-flexible', modifiedOccupancyFlag];
            $(document).off(...modifyListenersArgs);
            $(document).on(...modifyListenersArgs);
            thn.pageUnload(function () {
                canGetData = true;
            });
        }
        const root = document.querySelector('#root, .roi-room');
        if (root && !thn.roibackObserver) {
            thn.roibackObserver = function thnRoibackObserver(mutations) {
                // update only when dates/currency selectors are inserted into the DOM
                const elementMatch = Array.from(mutations).some((mutation) => {
                    const elementClass = (mutation.addedNodes[0] || {}).className || (mutation.target || {}).className;
                    // We don' want to update the PW when the price tab in Lopesan hotels is changed. To do this, we must exclude the mutations that are generated when changing the prices tab.
                    if (thn.data.accountUserId === 1021893) {
                        return typeof elementClass === 'string' // svg elements return 'SvgAnimatedString' instead of a string.
                            && elementClass.match(/-select|LoyaltyPrice|precio-|-price__amount/) && !elementClass.match(/(contenedor-precio)|(precio-descuento)/);
                    }
                    return typeof elementClass === 'string' // svg elements return 'SvgAnimatedString' instead of a string.
                        && elementClass.match(/-select|LoyaltyPrice|precio-|-price__amount/);
                });
                if (elementMatch) {
                    // Refresh PW
                    roibackRefresh();
                }
            };
            // Init body observation
            thn.observeDom(root, thn.roibackObserver, {
                childList: true,
                subtree: true,
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(root, thn.roibackObserver);
                delete thn.roibackObserver;
            });
        }
        const usersHidePW = [1041277];
        if (dataLayer && usersHidePW.includes(thn.data.accountUserId)) {
            const hidePrice = ({ message }) => {
                if (message.event === 'occupancy_change') {
                    thn.widgets.price.hide();
                }
            };
            thn.bus.on('dataLayer:push', hidePrice);
            thn.pageUnload(() => {
                thn.bus.detach('dataLayer:push', hidePrice);
            });
        }
        // mark a flag to apply priceSpecial if filters are set
        if (document.querySelector('[name=filtro-habs]')) {
            const undelegate = thn.delegate('click', '[name=filtro-habs]', ({ target }) => {
                // the "show all rooms" element has no 'data-tipo' attribute
                // the rest will be truthy and trigger the priceSpecial
                // Logic extracted from roiback's own event listener to hide/show rooms based on filters
                thn.data.roibackActiveRoomFilter = !!target.getAttribute('data-tipo');
            });
            thn.pageUnload(undelegate);
        }
        if ([1037958, 1032201, 1032630, 1032690].includes(thn.data.accountUserId)) {
            const containerMobile = document.querySelector('html');
            if (containerMobile && !thn.roibackObserverMobile) {
                thn.roibackObserverMobile = function (mutations) {
                    const validMutationsRefresh = [...mutations].map((mutation) => mutation.type === 'childList'
                        && mutation.nextSibling && mutation.nextSibling.className === 'dates-select').filter((el) => !thn.empty(el));
                    if (validMutationsRefresh.length) {
                        ctx.widget.refresh();
                    }
                };
                thn.observeDom(containerMobile, thn.roibackObserverMobile, {
                    childList: true,
                    subTree: true,
                    attributes: true,
                });
                thn.pageUnload(function () {
                    thn.stopObserveDom(containerMobile, thn.roibackObserverMobile);
                    delete thn.roibackObserverMobile;
                });
            }
        }
    };
    /**
       * @memberOf module:bs_8
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange() {
        /*
             * Only call the following function for certain properties.
             * 1012911 - Villa Del Palmar Puerto Vallarta
             * 1013116 - Villa Del Palmar Beach Resort & Spa Los Cabos
             */
        const isExcellencePlayaMujeresHP = thn.data.propertyId === 1011107 && homePage;
        const allowedProperties = [
            1012911,
            1013116,
            1011165,
            1011166,
            1027343,
        ].includes(thn.data.propertyId);
        if (allowedProperties || isExcellencePlayaMujeresHP) {
            setTimeout(thn.pageCheck, 500);
        }
    };
    /**
       * The great jungle, take care.
       *
       * It is not possible to implement **noRooms**.
       *
       * Generally omits rooms with pax 1, with some exceptions.
       *
       * Generally detects data even with **promocode** presence,
       * with some exceptions.
       *
       * @memberOf module:bs_8
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        $ = window.jQuery;
        if (!canGetData) {
            thn.widgets.price.logger.debug('Modified occupancy of a room, or showing flexible rate, we cannot guarantee the BAR');
            return widgetData;
        }
        const agencyUserType = window.dataLayer && thn.dataLayerHelper.get('userType') === 'Agency';
        const hidePwForAgencyLoggedIn = [1036687].includes(thn.data.accountUserId) && (document.getElementById('modoagencias') !== null || (agencyUserType && thn.dataLayerHelper.get('loginStatus') === 'yes'));
        const isRestricted = () => ((thn.data.propertyId === 1024941) && agencyUserType) || hidePwForAgencyLoggedIn;
        if (isRestricted()) {
            this.logger.warn('Execution not allowed: detected agency user');
            widgetData.set = false;
            return widgetData;
        }
        if (isNotFullyLoaded()) {
            widgetData.set = false;
            return widgetData;
        }
        const promocodeBlacklist = ['RESIDENCES'];
        const { promocode } = ctx.widget.getPromocode();
        // list here hotels  which must NOT show PW with promocode presence
        // Tafer Hotels
        const isPromocodeException = [1012150, 1012151, 1012827, 1013153, 1012730].includes(thn.data.propertyId);
        // Flag as priceSpecial when a promocode is applied (and you don't want to disable the price comparison)
        const flagPromocodeAsSpecialRate = promocode && [1021871, 1033632].includes(thn.data.accountUserId);
        const mobileScript = document.querySelector('script[src*="/bookcore/static/webmobile/"]');
        const reactVersion = !!(document.querySelector && (document.querySelector('.container-dispo [data-reactroot]') || mobileScript));
        let tmp;
        const usesRewardRate = ![1037958].includes(thn.data.accountUserId) || [1011936, 1011921, 1011935, 1011938, 1011939, 1011941, 1011943, 1011947, 1013217].includes(thn.data.propertyId);
        const isCallcenterMode = !!(($ && $('#modocallcenter:visible').length)
            || (document.getElementById('modocallcenter') && thn.isVisible(document.getElementById('modocallcenter'))));
        if (promocode // promocode presence AND
            && (isPromocodeException // whether the property is an exception
                || ( // OR the promocode is blacklisted
                promocodeBlacklist.includes(promocode)
                    || promocodeBlacklist.some(function (pattern) { return !!promocode.match(new RegExp(pattern)); })))) {
            // Do not execute PW at all
            this.logger.warn('Promocode found and handled: avoid PW comparison');
            return widgetData;
        }
        if (flagPromocodeAsSpecialRate) {
            widgetData.priceSpecial = 1;
        }
        // 2018-09-07: Do not exec PW if RR is in callcenter mode (special rates, etc)
        if (isCallcenterMode) {
            this.logger.warn('Callcenter mode detected: avoid PW comparison');
            return widgetData;
        }
        // 2018-08-09: Do not execute PW if any rate is found in the URL parameters
        if (!thn.empty(thn.parseUrlParameter('co'))) {
            this.logger.warn("Special Rate found! Don't execute PW.");
            return widgetData;
        }
        const isTaferResortBlacklist = thn.data.chainId === 1000396 && promocode && (/wedding$/i).test(promocode);
        if (isTaferResortBlacklist) {
            this.logger.warn("Wedding promocode used. Don't execute PW");
            return widgetData;
        }
        // On Roiback, when a user makes a search that cannot satisfy the occupancy, but it does on the dates
        // Roiback will add additional pages with different occupancy as an alternative
        // Some clients don't want that
        const noRoomsOnAlternativeRooms = [1036556, 1032201, 1032187, 1021871, 1033436].includes(thn.data.accountUserId);
        // Check for a separator which contains
        //  - "Sorry, the accommodation type you have selected is not available, please choose a different one"
        const noRoomsSeparatorElement = document.querySelector('.dispo_habitaciones > .roi-room__separator')?.textContent?.match(/not\savailable|ocupaciones?\sdiferentes?|andere\sbelegungen|plus\sdisponible|non\s.\sdisponibile/i);
        const noRoomsException = noRoomsSeparatorElement && noRoomsOnAlternativeRooms;
        // In some cases we want to ignore those alternative rooms but we want to parse the initial rooms that satifiest the search
        const ignoreAlternativeRooms = [1036556, 1032220, 1032630, 1032648, 1033870, 1045376, 1032858, 1039756, 1031930, 1032054, 1032537, 1035782, 1034975].includes(thn.data.accountUserId);
        // IMPROVEMENT: Add more translations
        const otherOccupanciesPattern = /other\saccommodations?|otras\socupaciones/;
        const otherOccupanciesSeparatorElement = [...document.querySelectorAll('.notification__text')]
            .filter((el) => el.textContent?.match(otherOccupanciesPattern));
        const ignoreAlternativeRoomsException = ignoreAlternativeRooms && otherOccupanciesSeparatorElement.length;
        // 2018-06-20: Same list for Desktop & Mobile versions.
        // Properties & user ids which want to include prices for individual rooms.
        const onePaxPropList = [1000040, 1012988, 1013064, 1000729, 1012974, 1014650, 1015208, 1000098, 1000099, 1015447, 1014480, 1013948, 1025201, 1026765, 1013057, 1027350, 1032994, 1033963, 1011853, 1011855, 1011856, 1025190, 1028444, 1028445, 1047387, 1024943];
        const onePaxUserList = [1036556, 1032008, 1032171, 1032570, 1032839, 1032382, 1033870, 1045376, 1033996, 1021893, 1033605, 1036722, 1021871, 1036763, 1036208, 1038514, 1037958, 1032201, 1032220,
            1034463, 1033088, 1034325, 1033104, 1036508, 1036650, 1032690, 1032346, 1035782, 1036657, 1032054, 1039915, 1040211, 1032858, 1032648, 1039756, 1039868, 1036777, 1031930, 1032607, 1040863, 1033846, 1032217, 1032264, 1033436, 1037133, 1034975];
        let price = false;
        const isPriceByNight = [1032690].includes(thn.data.accountUserId);
        // React version
        if (reactVersion) {
            if (document.querySelector('[data-chacking-selected]')) {
                widgetData.dateBegin = document.querySelector('[data-chacking-selected]').getAttribute('data-chacking-selected').replace(/-/g, '/');
                widgetData.dateEnd = document.querySelector('[data-chackout-selected]').getAttribute('data-chackout-selected').replace(/-/g, '/');
            }
            else if (document.querySelector('input#id_entrada')) {
                widgetData.dateBegin = document.querySelector('input#id_entrada').value.trim().split('/').reverse().join('/');
                widgetData.dateEnd = document.querySelector('input#id_salida').value.trim().split('/').reverse().join('/');
            }
            else if (document.querySelector('.dates-select__checkin') && document.querySelector('.dates-select__checkout') && !!engine._getDateFormat()) {
                const domDateBegin = (document.querySelector('.dates-select__checkin').textContent || '');
                const domDateEnd = (document.querySelector('.dates-select__checkout').textContent || '');
                if (dateFormat === 'MM-DD-YYYY') {
                    widgetData.dateBegin = domDateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
                    widgetData.dateEnd = domDateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
                }
                else if (dateFormat === 'DD-MM-YYYY') {
                    widgetData.dateBegin = domDateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    widgetData.dateEnd = domDateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                }
            }
            else if (window.dataLayer) {
                const dateBegin = thn.dataLayerHelper.get('checkinDate');
                const dateEnd = thn.dataLayerHelper.get('checkoutDate');
                widgetData.dateBegin = dateBegin && dateBegin.replace(/-/g, '/');
                widgetData.dateEnd = dateEnd && dateEnd.replace(/-/g, '/');
            }
            else if (document.querySelector('[data-checkin]') && document.querySelector('[data-checkout]')) {
                widgetData.dateBegin = (document.querySelector('[data-checkin]').getAttribute('data-checkin') || '').replace(/-/g, '/');
                widgetData.dateEnd = (document.querySelector('[data-checkout]').getAttribute('data-checkout') || '').replace(/-/g, '/');
            }
            widgetData.price = Number.MAX_VALUE;
            // In some properties, we need to exclude additional rooms
            // to do so, we need to ignore elements after a "other accommodations" separator
            let otherOccupancySeparatorFound = false;
            let roomElements = [];
            if (ignoreAlternativeRoomsException) {
                // Ignore rooms after a "other accommodations" separator
                [...document.querySelectorAll('[data-room] , .fnRoomsCards, [type="warning"] .notification__text')].forEach((el) => {
                    // IMPROVEMENT: Add more translations to the pattern
                    if ((el.textContent || '').match(otherOccupanciesPattern)) {
                        otherOccupancySeparatorFound = true;
                    }
                    if (!otherOccupancySeparatorFound
                        && (el.classList.contains('fnRoomsCards') || el.hasAttribute('data-room'))) {
                        roomElements.push(el);
                    }
                });
            }
            else {
                roomElements = [...document.querySelectorAll('[data-room] , .fnRoomsCards')];
            }
            // ****  ****
            // for each room
            roomElements.filter(function (el) {
                return thn.isVisible(el);
            }).forEach(function (room) {
                // for each room price
                // We also try to get the Reward/Membership rates (the clients use this rate changes the OTA price accordingly, most of the time, to the Reward price)
                let priceSelector = ':not(.precio-total-anterior):not(.precio-medio)[data-price]';
                if (usesRewardRate) {
                    priceSelector += ', [class*=LoyaltyPriceAmount]';
                }
                else {
                    // Avoid reading the element with data-price that contain loyalty rates
                    priceSelector += ':not([class*=Loyalty])';
                }
                const isInvisaHotel = thn.data.accountUserId === 1032648;
                Array.from(room.querySelectorAll(priceSelector)).filter(function (el) {
                    return thn.isVisible(el);
                }).forEach(function (el) {
                    price = thn.parseNumber(el.textContent);
                    const guestsArray = ((room.querySelector('.room-card__room-occupancy-text > span:not(.room-card__room-occupancy-icons):not(.room-card__room-occupancy-max-occupants), .room-occupancy__text>span:nth-child(2), div[class*="Occupancy"] > span[class*="Occupancy"]') || {}).textContent || '').split(',').map(function (text) {
                        return parseInt((text.match(/\d+/) || [])[0], 10) || 0;
                    });
                    let guests = 0;
                    guestsArray.forEach((num) => { guests += num; });
                    // There are hotels that the occupancy of 1 guest should be counted as 2 (maximum occupancy).
                    if (isInvisaHotel && guests === 1) {
                        guestsArray[0] = 2;
                        guests = 2;
                    }
                    if (guests >= 2 // Ignore rooms with capacity < 2
                        || onePaxPropList.includes(thn.data.propertyId) // except for NuevoBoston Hotel, The Pod Capsule Hotel, Palacio Estoril, Weare Chamartin, Cadiz Plaza, Hotel Horus Zamora, Mon Port Hotel & Spa, La Pergola Aparthotel Andratx, Hotel Conqueridor
                        || onePaxUserList.includes(thn.data.accountUserId)) { // except for Windsor Suites, Singgasana Hotels, Estelar, Tafer, Marlin, pobladohoteles, Alua)
                        if (price < widgetData.price) {
                            if (!widgetData.guests || widgetData.guests === guests) {
                                widgetData.price = price;
                                widgetData.currency = thn.getCurrencyCode(((el.textContent || '').match(/[^\d\s,.]+/) || [])[0]);
                                widgetData.adults = guestsArray[0];
                                widgetData.children = guestsArray.length > 1 ? guestsArray[1] : 0;
                                widgetData.guests = widgetData.adults + widgetData.children;
                            }
                        }
                    }
                });
            });
            if (thn.data.media.name === 'mobile') {
                const pricesSelector = (isUserUsingLoyaltyRates || isSirenisPropertyUsingLoyaltyRates || isAmResortPropertyUsingLoyaltyRates) ? '[class*=LoyaltyPriceAmountStyles], [data-testid=fn-loyalty-locked-price]' : '[class*=Pricesstyles__PriceStyle], strong[data-price]';
                const roomsInfo = [...document.querySelectorAll('.fnRoomsCards')].map((room) => {
                    price = thn.parseNumber(room.querySelector(pricesSelector)?.textContent);
                    const currency = !widgetData.currency ? thn.parseCurrency(room.querySelector('.prices')?.textContent) : widgetData.currency;
                    const guestsArray = room.querySelector('span span:nth-child(2)')?.textContent?.split(',');
                    const guests = !thn.empty(guestsArray) && guestsArray.map((el) => thn.parseNumber(el.match(/\d+/)));
                    const children = guestsArray[1]?.match(/\d ((C|c)hildren|(C|c)hild|(N|n)iño(s)?|(C|c)riança(s)?)/);
                    const babies = (guests.length > 2 && guests[2]) || (guests.length === 2 && !children && guests[1]) || 0;
                    const adultsByDataLayer = thn.dataLayerHelper.get('adultsNumber') || 2;
                    const childrenByDataLayer = thn.dataLayerHelper.get('childrenNumber') || 0;
                    const babiesByDataLayer = thn.dataLayerHelper.get('babiesNumber') || 0;
                    const isTheSameOccupancy = adultsByDataLayer === guests?.[0] && childrenByDataLayer === (guests?.[1] || 0) && babiesByDataLayer === babies;
                    // on mobile we don't have any separator element to ignore alternative rooms
                    if (ignoreAlternativeRooms && !isTheSameOccupancy) {
                        return {};
                    }
                    const roomInfoMobile = {
                        price,
                        currency,
                        adults: guests.length > 0 && guests[0],
                        children: children ? guests[1] + babies : babies,
                        childrenAges: [],
                    };
                    for (let i = 1; i <= roomInfoMobile.children; i += 1) {
                        // Populate children ages, with 10 for each child (7-12) and 1 for each infant (0-6)
                        roomInfoMobile.childrenAges.push(i <= roomInfoMobile.children - babies ? 10 : 1);
                    }
                    return roomInfoMobile;
                }).sort((a, b) => a.price - b.price).filter(Boolean);
                if (!thn.empty(roomsInfo)) {
                    widgetData.price = roomsInfo[0]?.price;
                    widgetData.currency = roomsInfo[0]?.currency;
                    widgetData.roomsDispo = [roomsInfo[0]];
                }
            }
            if (!price) {
                const prices = [];
                let guests;
                Array.from(document.querySelectorAll('.room-card, .habitacion')).forEach(function (room) {
                    const roomGuests = room.querySelectorAll('.room-card__room-occupancy-icon-full, .room-card__occupancy-icon-full, .room-occupancy__icon-full, .icons_people_wrap:not(.empty_occupation)').length;
                    Array.from(room.querySelectorAll('.room-card__board-price-amount, .board__price-amount, .rate__price-amount, .fare__price-amount, .roi-boards-total-price__amount')).forEach(function (_price) {
                        const ratePrice = thn.parseNumber(_price.textContent);
                        // If the current property has especified the 1-Pax-price rate, include it
                        if ((roomGuests > 1
                            || (onePaxPropList.includes(thn.data.propertyId))
                            || onePaxUserList.includes(thn.data.accountUserId))
                            && (!guests || guests === roomGuests)) {
                            guests = roomGuests;
                            prices.push({
                                adults: roomGuests,
                                price: ratePrice,
                            });
                        }
                    });
                });
                if (prices.length) {
                    const minPrice = prices.reduce(function (prev, curr) {
                        return (curr.price < prev.price) ? curr : prev;
                    });
                    let currency;
                    const currencyEl = ((document.querySelector('.prices') || {}).textContent || '').split(' ');
                    if (currencyEl.length === 2) {
                        currency = currencyEl[0].match(/.*[0-9]/) ? currencyEl[1] : currencyEl[0];
                    }
                    widgetData.adults = minPrice.adults || 1;
                    widgetData.children = 0;
                    widgetData.guests = widgetData.adults + widgetData.children;
                    widgetData.price = minPrice.price;
                    widgetData.currency = thn.getCurrencyCode(currency || '')
                        || thn.dataLayerHelper.get('currency');
                }
            }
            if (widgetData.price
                && widgetData.price !== Number.MAX_VALUE
                && widgetData.dateBegin
                && widgetData.dateEnd) {
                widgetData.price = isPriceByNight ? widgetData.price : widgetData.price / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
                widgetData.set = true;
            }
            else {
                widgetData.price = undefined;
                // no-rooms case for PrincePark and Abades Group
                if ((document.querySelector('.no_dispo_titulo') != null) && (document.querySelectorAll('.no_dispo_titulo').length > 0)) {
                    widgetData.noRooms = true;
                }
            }
            // regular Roiback version
        }
        else if ($) {
            // helper functions
            let filterWithMinimum;
            const getClosestOcupancyCode = function getClosestOcupancyCode(element) {
                let adults = 0, children = 0, babies = 0;
                const parent = $(element).closest('.habitacion'), $adults = $('.hab_ocupacion_adultos em', parent), $children = $('.hab_ocupacion_ninos em', parent), $babies = $('.hab_ocupacion_bebes em', parent), $select = $('.ocupselecc select', parent);
                if ($select.length) {
                    // code is already prepared for us :)
                    return $select.val();
                }
                if ($adults.length) {
                    adults = parseInt($adults.text(), 10);
                }
                if ($children.length) {
                    children = parseInt($children.text(), 10);
                }
                if ($babies.length) {
                    babies = parseInt($babies.text(), 10);
                }
                return [adults, children, babies].join('-');
            };
            // Currency
            if (($('#monedas') != null) && (thn.data.propertyId !== 1024941) && ($('#monedas').length) && ($('#monedas').val().length === 3)) {
                widgetData.currency = $('#monedas').val();
            }
            if (thn.data.propertyId === 1024941) {
                widgetData.currency = thn.parseCurrency(document.querySelector('.contenedor-precio')?.textContent);
            }
            if (($('#currency') != null) && ($('#currency').length) && ($('#currency').val().length === 3)) {
                widgetData.currency = $('#currency').val();
            }
            if ($('.currency-select').length) { // React mobile version
                widgetData.currency = $('.currency-select select option:selected').text();
            }
            if (!widgetData.currency) {
                // multiprecio example:
                // <span class="multiprecio" data-usd="$185.00">$185.00</span>
                const $multi = $('.multiprecio:eq(0)'), currency = $multi.length > 0 && $multi.text().match(/[^\d\s.,]+/);
                if (currency && currency.length) {
                    widgetData.currency = thn.getCurrencyCode(currency[0]);
                }
            }
            if (!widgetData.currency) {
                if ($('meta[name="defaultHotelCurrency"]').length || document.querySelector('.fn-currency-select [data-conversion="1"]')) {
                    widgetData.currency = $('meta[name="defaultHotelCurrency"]')?.attr('content') ?? document.querySelector('.fn-currency-select [data-conversion="1"]')?.value;
                }
            }
            // Dates
            const isValidDateFormat = ([dateBegin, dateEnd]) => {
                const dateFormatRegex = /^\d{4}\/\d{2}\/\d{2}$/;
                return dateFormatRegex.test(dateBegin) && dateFormatRegex.test(dateEnd);
            };
            const getDates = () => {
                const rawDates = $('.subcabecera_main').text().trim().match(/([0-9]*)\/([0-9]*)\/([0-9]*)/g);
                if ((rawDates != null) && (rawDates.length === 2)) {
                    const rawDateBegin = rawDates[0];
                    const dateBegin = `${rawDateBegin.substr(6, 4)}/${rawDateBegin.substr(3, 2)}/${rawDateBegin.substr(0, 2)}`;
                    const rawDateEnd = rawDates[1];
                    const dateEnd = `${rawDateEnd.substr(6, 4)}/${rawDateEnd.substr(3, 2)}/${rawDateEnd.substr(0, 2)}`;
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                if (dataLayer && thn.arrayGet(dataLayer, 'checkinDate') && thn.arrayGet(dataLayer, 'checkoutDate')) {
                    const dateBegin = thn.arrayGet(dataLayer, 'checkinDate').replace(/-/g, '/');
                    const dateEnd = thn.arrayGet(dataLayer, 'checkoutDate').replace(/-/g, '/');
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                if ($('#id_entrada_txt').length && $.fn.datepicker && $('#id_entrada').datepicker('getDate')) {
                    const rawDateBegin = new Date($('#id_entrada_txt').datepicker('getDate'));
                    const rawDateEnd = new Date($('#id_salida_txt').datepicker('getDate'));
                    const dateBegin = (`${rawDateBegin.getFullYear()}/${rawDateBegin.getMonth() + 1}/${rawDateBegin.getDate()}`);
                    const dateEnd = (`${rawDateEnd.getFullYear()}/${rawDateEnd.getMonth() + 1}/${rawDateEnd.getDate()}`);
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                const checkInInput = document.querySelector('#id_entrada')?.value;
                const checkOutInput = document.querySelector('#id_salida')?.value;
                if (checkInInput && checkOutInput) {
                    const dateBegin = checkInInput.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    const dateEnd = checkOutInput.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                if ($('#arrival').length && $.fn.pickadate && $('#arrival').pickadate('picker').get('select')) {
                    const dateBegin = $('#arrival').pickadate('picker').get('select', 'yyyy/mm/dd');
                    const dateEnd = $('#departure').pickadate('picker').get('select', 'yyyy/mm/dd');
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                if ($('#x-dates-selected').length) { // React mobile version
                    // Warning: Indeed a very strange data name, keep an eye here
                    // they may change it to something more standard at some point
                    const dateBegin = $('#x-dates-selected').data('chacking-selected').replace(/-/g, '/');
                    const dateEnd = $('#x-dates-selected').data('chackout-selected').replace(/-/g, '/');
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                if ($('#id_entrada-widget-0').length && $('#id_salida-widget-0').length) {
                    const dateBegin = $('#id_entrada-widget-0').attr('data-roicalendar-initial-date').replace(/-/g, '/');
                    const dateEnd = $('#id_salida-widget-0').attr('data-roicalendar-initial-date').replace(/-/g, '/');
                    if (isValidDateFormat([dateBegin, dateEnd])) {
                        return [dateBegin, dateEnd];
                    }
                }
                const dateBegin = (document.querySelector('[data-checkin]')?.getAttribute('data-checkin') || '').replace(/-/g, '/');
                const dateEnd = (document.querySelector('[data-checkout]')?.getAttribute('data-checkout') || '').replace(/-/g, '/');
                if (isValidDateFormat([dateBegin, dateEnd])) {
                    return [dateBegin, dateEnd];
                }
                return null;
            };
            const dates = getDates();
            if (!thn.empty(dates)) {
                widgetData.dateBegin = dates[0];
                widgetData.dateEnd = dates[1];
            }
            // Guests and Rooms
            if (($('input[name=dui]') != null) && ($('input[name=dui]').length > 0)) {
                widgetData.guests = $('input[name=dui]').data('datos').ocupaciones[0].codigo.substr(0, 1);
            }
            // guests for mobile version 'Backhotel Mobile by Roiback'
            // Example property: 1011279 - https://en.hotelimperiallaguna.com/m/
            if (!widgetData.guests && document.querySelector('.byroiback')) {
                if (document.querySelector('.byroiback').innerText === 'Backhotel Mobile by Roiback') {
                    // Guests
                    const guestsSelector = document.querySelector('.ocupacion').querySelector('select');
                    if (guestsSelector) {
                        const guests = guestsSelector.options[guestsSelector.selectedIndex].value;
                        const guestsArr = guests.split('-');
                        widgetData.adults = parseInt(guestsArr[0], 10) || 2;
                        widgetData.children = parseInt(guestsArr[1], 10) || 0;
                        widgetData.guests = widgetData.adults + widgetData.children;
                    }
                }
            }
            // Price
            widgetData.price = undefined;
            if (($('input[name=dui]') != null) && ($('input[name=dui]').length > 0)) {
                widgetData.price = $('input[name=dui]').data('datos').ocupaciones[0].pensiones[0].ntotal[widgetData.currency];
            }
            else if ($('.tarifa[data-datos]').length) {
                filterWithMinimum = function (atLeast, options) {
                    atLeast = atLeast || 0;
                    options = { adults: true, children: false };
                    return function _factory(idx, el) {
                        const codigo = getClosestOcupancyCode(el);
                        // make a deep copy of the data object
                        const datos = $.extend({}, $(el).data('datos'));
                        // get only the ocupancy that match the *selected* ocupancy on that rate
                        datos.ocupaciones = $.grep(datos.ocupaciones, function (ocup) {
                            const parts = ocup.codigo.split('-');
                            let capacity = 0;
                            if (options.adults) {
                                capacity += parseInt(parts[0], 10) || 0;
                            }
                            if (options.children) {
                                capacity += parseInt(parts[1], 10) || 0;
                            }
                            return ocup.codigo === codigo && capacity >= atLeast;
                        });
                        return datos;
                    };
                };
                let capacity = 2;
                let datos;
                do {
                    // collect all the data from all the rates
                    datos = $('.tarifa[data-datos]').map(filterWithMinimum(capacity)).toArray();
                    // filter out any data without ocupancies
                    datos = $.grep(datos, function (dato) {
                        return dato.ocupaciones.length;
                    });
                    capacity -= 1;
                    // repeat while there are no prices that fullfill the minimum criteria
                    // and there is a minimum capacity
                } while (datos.length < 1 && capacity > 0);
                const prices = $.map(datos, function (tarifa) {
                    // there should by only one ocupancy because it was previously filtered
                    const pensiones = $.map(tarifa.ocupaciones[0].pensiones, function (pension) {
                        if ($.isArray(pension)) {
                            const subprices = $.map(pension, function (subpension) {
                                return subpension.total[widgetData.currency] || Number.MAX_VALUE;
                            });
                            const idx = subprices.indexOf(Math.min.apply(null, subprices));
                            return pension[idx].total[widgetData.currency] || Number.MAX_VALUE;
                        }
                        return pension.total[widgetData.currency] || Number.MAX_VALUE;
                    });
                    // return the minimum price for this rate
                    return {
                        code: tarifa.ocupaciones[0].codigo,
                        price: Math.min.apply(null, pensiones),
                    };
                });
                // set the price as the minimum price of all the rates
                $.each(prices, function (idx, rate) {
                    const guests = rate.code.split('-');
                    const adultsTotal = parseInt(guests[0], 10) || 2;
                    const childrenTotal = parseInt(guests[1], 10) || 0;
                    const babiesTotal = parseInt(guests[2], 10) || 0;
                    const guestsTotal = adultsTotal + childrenTotal;
                    if ((widgetData.price === undefined
                        || rate.price < widgetData.price)
                        && (!widgetData.guests || widgetData.guests === guestsTotal)) {
                        widgetData.price = rate.price;
                        widgetData.adults = adultsTotal;
                        widgetData.children = childrenTotal;
                        widgetData.babies = babiesTotal;
                        widgetData.guests = guestsTotal;
                    }
                });
            }
            else {
                let selector = '';
                // decide the right selector
                if ($('.precio_despues').length) {
                    selector = '.precio_despues';
                }
                else {
                    selector = ':not(.precio-total-anterior):not(.precio-medio)[data-price]';
                }
                const includeHiddenPrices = [
                    1013064, // Palacio Estoril
                    1000466, // hotel perla benidorm
                    1000395, // arabian courtyard
                ].includes(thn.data.propertyId) || [
                    1032354, // GHL Hotels
                ].includes(thn.data.accountUserId);
                if (!includeHiddenPrices) {
                    // (default) do not incluce non-visible prices
                    selector += ':visible';
                }
                // Rates whitelist
                const tarifacodWhitelist = {
                    1000756: ['anticipada', 'estandar'], // Hotel Lauria
                };
                // For property = 1027632, no need to exclude member rates. Keeping the code in case they want to exclude them again
                // Rates blacklist
                let ratesBlacklistSelector = '';
                if (thn.data.propertyId === 1027632) {
                    // Exclude pithces/parcelas
                    ratesBlacklistSelector = '.pension_ocupacion[id^=parcela]';
                }
                // Get Element Prices + filter out some
                tmp = $(selector).filter(function (idx, el) {
                    const $el = $(el);
                    // note: sometimes "selector":visible is not enought to filter the right prices
                    // if the price is contained in a popover div, then ignore it
                    if ($el.closest('.popover, .popover-markup').length) {
                        return false;
                    }
                    // Remove striked-through prices
                    // When the hotel applied one discount, we can see two prices, the final price and the price before applying the discount. We need to exclude the second one
                    // Have in mind that we are insterested on collecting Memebership/Reward rates, and those rates also shares the class 'js-rate-discount-amount-locked'
                    if ($el.closest('.precio_ant').length || $el[0].classList.contains('precio-total-anterior')) {
                        // If we find an elemenet with ".precio_ant or .precio-total-anterior" we will exclude this rate if:
                        // - The element doesn't contains the class .js-boards-discount-amount-locked, which is used for Reward/Membership Rates
                        // - the property we are in it's an exception to exclude exclude Reward/Memebership Rates
                        const classNames = ['js-rate-discount-amount-locked', 'js-boards-discount-amount-locked'];
                        if (!(classNames.some((className) => $el[0].classList.contains(className))) || !usesRewardRate) {
                            return false;
                        }
                    }
                    // remove avg prices
                    if ($el.closest('.precio_medio_noche').length) {
                        return false;
                    }
                    // moreover when including "hidden" prices
                    // make sure they are inside an active rate
                    // user 1032346 doesn't seem to use the active class
                    if (![1032346, 1033870, 1045376].includes(thn.data.accountUserId)
                        && !($el.closest('.pension_ocupacion').hasClass('active')
                            || $el.closest('.pensiones_box_item').hasClass('active'))) {
                        return false;
                    }
                    // Rates whitelist
                    if (tarifacodWhitelist[thn.data.propertyId]) {
                        const tarifacod = $el.closest('div[data-tarifacod]').attr('data-tarifacod');
                        if (tarifacod && !tarifacodWhitelist[thn.data.propertyId].includes(tarifacod)) {
                            return false;
                        }
                    }
                    // Ignore rates by checking it class or id
                    if (ratesBlacklistSelector && $el.closest(ratesBlacklistSelector).length) {
                        return false;
                    }
                    return true;
                });
                let group;
                const groupOnePax = '1-0-0';
                // Search Cheapest price
                tmp.each(function (index, element) {
                    let elementChildrenAges = [];
                    // note: sometimes "selector":visible is not enought to filter the right prices
                    // if the price is contained in a popover div, then ignore it
                    if ($(element).closest('.popover, .popover-markup').length) {
                        return;
                    }
                    if (ignoreAlternativeRooms && (foundSeparator || isAlternativeRate(element))) {
                        foundSeparator = true;
                        return;
                    }
                    if (thn.data.accountUserId === 1032690 // villadelpalmar
                        // exclude prices under "vlevel" rate
                        && $(element).closest('.roi-rate-price-vlevel').length) {
                        return;
                    }
                    if (thn.data.propertyId === 1028773 // Gambrinus Hotel
                        && element?.closest('figure')?.querySelector('h3')?.textContent?.trim()?.match(/ECONOMY SINGLE|CAMERA SINGOLA ECONOMY/)) {
                        return;
                    }
                    // User ID 1034463 - PortBlue
                    // Finding a separator above the rooms box means that the following rates are just alternatives that don't fit all the searched guests.
                    // Break the loop, no more rates to check.
                    if (thn.data.accountUserId === 1034463 && ($(tmp[index]) != null) && ($(tmp[index]).closest('.habitacion') != null) && $(tmp[index]).closest('.habitacion').prev('.roi-room__separator').length) {
                        return;
                    }
                    // Room Group
                    if (($(tmp[index]) != null) && ($(tmp[index]).closest('.habitacion') != null) && ($(tmp[index]).closest('.habitacion').find('.socups') != null) && ($(tmp[index]).closest('.habitacion').find('.socups').length > 0) && ($(tmp[index]).closest('.habitacion').find('.socups').val() != null)) { // MonPort
                        group = $(tmp[index]).closest('.habitacion').find('.socups').val();
                        ctx.widget.logger.debug(`Roiback Type 1 ${group}`);
                    }
                    else if (($(tmp[index]) != null) && ($(tmp[index]).closest('.habitacion') != null) && ($(tmp[index]).closest('.habitacion').find('.lista_cupos .ocup') != null) && ($(tmp[index]).closest('.habitacion').find('.lista_cupos .ocup').length > 0)) { // Amister
                        group = $(tmp[index]).closest('.habitacion').find('.lista_cupos .ocup:eq(0)').data('codigo');
                        ctx.widget.logger.debug(`Roiback Type 2 ${group}`);
                    }
                    else if ((($(tmp[index]) != null) && ($(tmp[index]).closest('.habitacion') != null) && ($(tmp[index]).closest('.habitacion').find('.hab_ocupacion') != null) && ($(tmp[index]).closest('.habitacion').find('.hab_ocupacion').length > 0)) && (typeof $(tmp[index]).closest('.habitacion').find('.hab_ocupacion').data('ocupacion_seleccionada') !== 'undefined')) { // Nuevo Boston
                        const currentGuestsContainer = $(tmp[index]).closest('.habitacion').find('.hab_ocupacion');
                        const babies = thn.parseNumber(currentGuestsContainer.find('span.hab_ocupacion_bebes').text());
                        // for roomsDispo
                        group = currentGuestsContainer.data('ocupacion_seleccionada');
                        elementChildrenAges = currentGuestsContainer.find('.txt_edades_ninos').text().match(/\d+/g) || [];
                        if (babies) {
                            for (let i = 1; i <= babies; i += 1) {
                                elementChildrenAges.push('0');
                            }
                        }
                        ctx.widget.logger.debug(`Roiback Type 3 ${group}`);
                    }
                    else {
                        group = '2-0-0';
                        ctx.widget.logger.debug('Roiback Type 0');
                    }
                    // Assure Group is well formed
                    if (group.match(/[0-9]-[0-9]-[0-9]/) == null) {
                        group = '2-0-0';
                    }
                    if (parseInt(group.substr(0, 1), 10) >= 2 // ignore rooms with capacity < 2
                        || onePaxPropList.includes(thn.data.propertyId) // except for NuevoBoston Hotel, The Pod Capsule Hotel, Palacio Estoril, Weare Chamartin, Cadiz Plaza, Hotel Horus Zamora
                        || onePaxUserList.includes(thn.data.accountUserId)) { // except for Windsor Suites, Singgasana Hotels, Estelar, Tafer, Marlin, pobladohoteles
                        // Find cheapest Price
                        const roomPrice = thn.parseNumber($(this).text());
                        if (roomPrice
                            && (typeof widgetData.price === 'undefined'
                                || roomPrice < widgetData.price)
                            && (!validGuestsGroup || validGuestsGroup === group || group === groupOnePax)) {
                            // Don't store price if we are on no_rooms_exception (alternative prices)
                            if (!noRoomsException && !isUserUsingLoyaltyRates) {
                                widgetData.price = thn.parseNumber($(this).text());
                            }
                            // Check if priceSpecial
                            if (![1033870, 1045376].includes(thn.data.accountUserId)) {
                                widgetData.priceSpecial = flagPromocodeAsSpecialRate ? 1 : 0;
                            }
                            // re-check currency, do not trust the currency selector
                            let priceCurrency = ($(this).text().match(/[^\d\s,.]+/) || [])[0];
                            if ((priceCurrency && priceCurrency.match(/^[A-Z]{3}$/))
                                && priceCurrency !== widgetData.currency) {
                                // if this is an ISO code, then trust this as the ultimate source for the currency
                                widgetData.currency = priceCurrency;
                            }
                            // re-check currency, do not trust the currency selector
                            priceCurrency = ($(this).text().match(/[^\d\s,.]+/) || [])[0];
                            if (priceCurrency && priceCurrency !== '$') { // not for "$" sign, too much ambiguous
                                priceCurrency = thn.getCurrencyCode(priceCurrency); // get the ISO code
                                if (priceCurrency && priceCurrency !== widgetData.currency) {
                                    // finally if we got an ISO code and it differs
                                    // then trust this as the ultimate source for the currency
                                    widgetData.currency = priceCurrency;
                                }
                            }
                            if ((group != null) && (group.length === 5)) {
                                validGuestsGroup = group;
                                widgetData.adults = parseInt(group.substr(0, 1), 10);
                                widgetData.children = parseInt(group.substr(2, 1), 10);
                                let babies = parseInt(group.substr(4, 1), 10);
                                // ignore children,babies for Amaroossa Hotels
                                if (thn.data.accountUserId === 1032475) {
                                    widgetData.children = 0;
                                    babies = 0;
                                }
                                widgetData.guests = widgetData.adults + widgetData.children + babies;
                                widgetData.children += babies;
                                // room info
                                const room1Info = {
                                    adults: widgetData.adults,
                                    children: widgetData.children,
                                    childrenAges: [],
                                };
                                const urlChildrenAges = thn.parseUrlParameter('children-ages');
                                // If we are seeing alternative rooms, the occupancy data we find on the URL is incorrect
                                if (urlChildrenAges && !ignoreAlternativeRoomsException) { // eg pid 1016424 using url param
                                    const childrenAges = urlChildrenAges.split(',').map(Number);
                                    const parsedChildrenAges = childrenAges.map((age) => thn.parseNumber(age) || 1);
                                    room1Info.childrenAges = parsedChildrenAges;
                                }
                                else if (elementChildrenAges.length) { // eg pid 1014213 no url param
                                    if (!babies && elementChildrenAges.length === widgetData.children) {
                                        room1Info.childrenAges = elementChildrenAges;
                                    }
                                    else {
                                        for (let i = 1; i <= widgetData.children; i += 1) {
                                            room1Info.childrenAges.push(i <= elementChildrenAges - babies ? elementChildrenAges[i] : 0);
                                        }
                                    }
                                }
                                widgetData.roomsDispo = [room1Info];
                            }
                            widgetData.guests = widgetData.adults + widgetData.children;
                        }
                    }
                });
            }
            if (isUserUsingLoyaltyRates) {
                // ignore more options available with other accommodation types
                foundSeparator = false;
                const roomNodes = [...document.querySelectorAll('.habitacion')].filter((el) => {
                    if (!foundSeparator && el.previousSibling?.className?.indexOf('roi-room__separator') < 0) {
                        return true;
                    }
                    foundSeparator = true;
                    return false;
                });
                const loyaltyRates = roomNodes.map((roomNode) => [...roomNode.querySelectorAll('.roi-boards-locked-price__amount')].filter((rate) => thn.isVisible(rate))).flat()
                    .map((rate) => thn.parseNumber(rate?.textContent)).filter(Boolean);
                // Roiback modified their structure, we need to check for the new one
                const roomNodesV2 = [...document.querySelectorAll('div[class*=RateContentWrapper] section div[class*=pensiones_box_item], [data-testid=fn-availability-item]')];
                const loyaltyRatesV2 = roomNodesV2.map((roomNode) => [...roomNode.querySelectorAll('[data-testid=fn-board-total-price], div[class*=PriceDetailstyles__LoyaltyContainerStyles], [data-testid=fn-board-locked-price], [data-testid=fn-board-discount-price]')].filter((rate) => thn.isVisible(rate))).flat()
                    .map((rate) => thn.parseNumber(rate?.textContent)).filter(Boolean);
                // we check that the array is not null
                const cheaperLoyaltyRate = (!thn.empty(loyaltyRates) && Math.min(...loyaltyRates)) || (!thn.empty(loyaltyRatesV2) && Math.min(...loyaltyRatesV2));
                if (cheaperLoyaltyRate && (cheaperLoyaltyRate < widgetData.price || !widgetData.price)) {
                    widgetData.price = cheaperLoyaltyRate;
                }
            }
            // Ohai Nazaré
            if (thn.data.accountUserId === 1037921) {
                // Compare prices except for rooms ids with 'habitacion_parcela' and 'habitacion_parcpremium' for fair comparison
                const roomNodes = [...document.querySelectorAll('.habitacion')].filter((el) => el.id !== 'habitacion_parcela' && el.id !== 'habitacion_parcpremium');
                const ratesToCompare = roomNodes.map((roomNode) => [...roomNode.querySelectorAll('.roi-boards__block--total-price .precio-total')]).flat()
                    .map((rate) => thn.parseNumber(rate?.textContent)).filter(Boolean);
                // we check that the array is not null
                const lowestRate = !thn.empty(ratesToCompare) && Math.min(...ratesToCompare);
                if (lowestRate) {
                    widgetData.price = lowestRate;
                }
            }
            if (thn.data.accountUserId === 1037958) {
                const roomsDesktopNumber = [...document.querySelectorAll('.habitacion')].filter((el) => el.previousSibling && el.previousSibling.className !== 'roi-room__separator').map((room) => {
                    const adults = thn.parseNumber((room.querySelector('em.num_adultos') || {}).textContent);
                    const children = thn.parseNumber((room.querySelector('em.num_ninos') || {}).textContent);
                    const babies = thn.parseNumber((room.querySelector('em.num_bebes') || {}).textContent);
                    price = room.querySelector('.roi-rates__block--total-price .precio-total.roi-rate-total-price__amount') && thn.parseNumber(room.querySelector('.roi-rates__block--total-price .precio-total.roi-rate-total-price__amount').textContent);
                    const ages = ((room.querySelector('.txt_edades_ninos') || {}).textContent || '').match(/\d+/g) || [];
                    if (price) {
                        const infoRoom = {
                            adults: adults,
                            children: children + babies,
                            price: price,
                            childrenAges: [],
                        };
                        for (let i = 0; i < babies; i += 1) {
                            infoRoom.childrenAges.push(1);
                        }
                        for (let i = 0; i < ages.length; i += 1) {
                            infoRoom.childrenAges.push(thn.parseNumber(ages[i]));
                        }
                        return infoRoom;
                    }
                    return false;
                }).filter(Boolean);
                roomsDesktopNumber.sort((a, b) => a.price - b.price);
                if (roomsDesktopNumber.length) {
                    widgetData.roomsDispo = [roomsDesktopNumber[0]];
                    widgetData.price = roomsDesktopNumber[0].price;
                }
            }
            if (thn.data.roibackActiveRoomFilter) {
                widgetData.priceSpecial = 1;
            }
            // If we have some results Check Other Data
            if (widgetData.price && widgetData.dateBegin && widgetData.dateEnd) {
                // Divide Price by Nights
                // widgetData.price /= Math.round(thn.days_between(widgetData.dateBegin, widgetData.dateEnd), 2);
                // Round price
                const pricePerNightPropertylist = [1012911];
                const pricePerNightUserlist = [1037133, 1032630];
                const pricePerNight = pricePerNightUserlist.includes(thn.data.accountUserId) || pricePerNightPropertylist.includes(thn.data.propertyId) ? widgetData.price : Math.round((widgetData.price / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
                widgetData.price = pricePerNight;
                widgetData.set = true;
            }
            else if (noRoomsException) {
                widgetData.noRooms = true;
            }
            else if (($('.calendarios_hoteles_no_dispo') != null) && ($('.calendarios_hoteles_no_dispo').length > 0)) {
                widgetData.noRooms = true; // Amister
            }
            else if (($('#bc_cals_hoteles') != null) && ($('#bc_cals_hoteles').length > 0)) {
                widgetData.noRooms = true; // SercotelDali
            }
            else if (($('.no_dispo_titulo') != null) && ($('.no_dispo_titulo').length > 0)) {
                widgetData.noRooms = true; // PrincePark and Abades Group
            }
        } // regular version end
        // Room Details Function Here
        widgetData.roomDetails = engine._roomDetailsParseData();
        if (!widgetData.roomsDispo && !widgetData.adults && !widgetData.noRooms) {
            const adults = thn.parseNumber(document.querySelector('select[name=adultos]')?.value || thn.parseUrlParameter('adults') || 2);
            const children = thn.parseNumber(document.querySelector('select[name=ninos]')?.value || thn.parseUrlParameter('ninos') || 0);
            const infants = thn.parseNumber(document.querySelector('select[name=bebes]')?.value) || 0;
            const childrenAges = thn.parseUrlParameter('children-ages')?.split(',')?.map((age) => {
                if (age === '0') {
                    return 1;
                }
                return thn.parseNumber(age);
            }).filter(Boolean);
            const roomInfo = {
                adults,
                children: children + infants,
                childrenAges,
            };
            widgetData.roomsDispo = [roomInfo];
        }
        // There are cases where other Occupancy rooms are available,
        // but the alternative bar is at the top, and we do not set the PW data.
        // For example, if you search for 1 adult, all rooms are rooms that can accommodate more than 1 adult.
        // In this case, we need to collect PW data because they are rooms that can accommodate 1 adult.
        const isOtherOccupancyAvailable = (document.querySelector('.bc_actions')?.nextElementSibling?.className === 'roi-room__separator') && (document.querySelectorAll('.habitacion').length > 0);
        if (!widgetData.noRooms && widgetData.roomDetails && thn.data.accountUserId === 1031930 && isOtherOccupancyAvailable) {
            const cheapestPrices = widgetData.roomDetails.map((accommodation) => {
                const cheapestPrice = accommodation.prices.reduce((min, p) => (p.totalNight < min.totalNight ? p : min), accommodation.prices[0]);
                return {
                    name: accommodation.name,
                    adults: accommodation.adults,
                    children: accommodation.children,
                    cheapestPrice: cheapestPrice.totalNight,
                };
            });
            const cheapestRoom = cheapestPrices.sort((a, b) => a.cheapestPrice - b.cheapestPrice)[0];
            // We have to assign the PW data when rooms can accomodate the number of guests searched.
            if (widgetData.roomsDispo[0]?.adults <= cheapestRoom.adults) {
                widgetData.price = cheapestRoom.cheapestPrice;
            }
            else {
                widgetData.noRooms = true;
            }
        }
        if (thn.data.pageName === 'Calendar') { // price_target_pages is a setting that allows us to set the price for a specific page
            const adultsParamCalendarPage = thn.parseUrlParameter('adults') || 2;
            const childrenParamCalendarPage = thn.parseUrlParameter('ninos') || 0;
            const childrenAgesParamCalendarPage = thn.parseUrlParameter('children-ages')?.split(',')?.map((age) => {
                if (age === '0') {
                    return 1;
                }
                return thn.parseNumber(age);
            }).filter(Boolean) || [];
            widgetData.roomsDispo = [{
                    adults: thn.parseNumber(adultsParamCalendarPage),
                    children: thn.parseNumber(childrenParamCalendarPage),
                    childrenAges: childrenAgesParamCalendarPage,
                }];
        }
        return widgetData;
    };
    engine._roomDetailsParseData = function _roomDetailsParseData() {
        const roomDetailsArray = [];
        const roomSelector = document.querySelectorAll('.habitacion');
        const roomSelectorMobile = document.querySelectorAll('.fnRoomsCards');
        const breakfastText = /(desayuno|breakfast|petit-déjeuner|frühstück|media|half|demi|halbpension|full|completa|complète|vollpension)/i;
        const refundableText = /(flexible|gratis|gratuite|free|best|mejor|meilleur|bester|miglior)/i;
        let roomName, roomAdults, roomChildren;
        const typeRoomSelector = {
            Vip: 'vip',
            Premium: 'premium',
            Deluxe: 'deluxe',
            Suite: 'suite',
            Classic: 'classic',
            Superior: 'superior',
            Junior: 'junior',
            Family: 'family',
            Single: 'single',
            Twin: 'twin',
            Double: 'double',
            Triple: 'triple',
            Villa: 'villa',
        };
        if (roomSelector.length) {
            /* Desktop Version */
            /* For each Room */
            roomSelector.forEach(function (element, idx) {
                roomName = (element.querySelector('.hab_titulo') || {}).textContent || '';
                roomAdults = thn.parseNumber((element.querySelector('.num_adultos') || {}).textContent) || 2;
                roomChildren = thn.parseNumber((element.querySelector('.num_ninos') || {}).textContent) || 0;
                const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
                const roomData = {
                    id: '',
                    name: roomName,
                    adults: roomAdults,
                    children: roomChildren,
                    prices: [],
                };
                roomData.type = roomType;
                const priceInfo = element.querySelector('.pensiones')?.querySelectorAll('.pensiones_box_item.active') || [];
                // Iterate Prices
                if (!thn.empty(priceInfo.length)) {
                    priceInfo.forEach(function (priceUnit) {
                        const refundableBlock = priceUnit.parentElement.parentElement.getAttribute('data-tarifa') || '';
                        const priceItemName = (priceUnit.querySelector('.roi-rates__name') || {}).textContent || '';
                        const price = thn.parseNumber((priceUnit.querySelector('.precio-total') || {}).textContent);
                        const pricePerNight = thn.parseNumber((priceUnit.querySelector('.precio-medio') || {}).textContent);
                        const priceData = {
                            id: '',
                            name: priceItemName,
                            totalNight: pricePerNight || price,
                            breakfast: priceItemName.toLowerCase().match(breakfastText) ? 1 : 0,
                            refundable: refundableBlock.match(/"cancelable": true,/) ? 1 : 0,
                        };
                        roomData.prices.push(priceData);
                    });
                    roomDetailsArray.push(roomData);
                }
            });
        }
        else if (thn.data.media.name === 'mobile') {
            /* Mobile Version */
            const nights = thn.parseNumber((document.querySelector('.dates-select__nights') || {}).textContent);
            roomSelectorMobile.forEach(function (element, idx) {
                roomName = (element.querySelector('.Roomstyles__RoomName-sc-oq6k0q-1') || {}).textContent || '';
                roomAdults = thn.parseNumber(((element.querySelector('.OccupancyPreviewstyles__ResumeStyles-sc-r2fpae-3') || {}).textContent || '').split(',')[0]) || 2;
                roomChildren = thn.parseNumber(((element.querySelector('.OccupancyPreviewstyles__ResumeStyles-sc-r2fpae-3') || {}).textContent || '').split(',')[1]) || 0;
                const roomType = (Object.keys(typeRoomSelector).filter((key) => ((roomName)).toLowerCase().includes(typeRoomSelector[key]))[0] || 'Standard');
                let pricePerNight;
                const roomData = {
                    id: '',
                    name: roomName,
                    adults: roomAdults,
                    children: roomChildren,
                    prices: [],
                };
                roomData.type = roomType;
                const priceInfo = element.querySelectorAll('.Boardstyles__BoardStyles-sc-ti5dfe-0');
                // Iterate Prices
                if (priceInfo.length) {
                    priceInfo.forEach(function (priceUnit) {
                        const refundableBlock = (priceUnit.querySelector('.MobileAvailabilityOptionstyles__TitleStyles-sc-jhntad-1') || {}).textContent || '';
                        const priceItemName = (priceUnit.querySelector('.Boardstyles__NameStyles-sc-ti5dfe-2') || {}).textContent || '';
                        const price = thn.parseNumber((priceUnit.querySelector('.ZMKPn.prices') || {}).textContent);
                        if (price && nights) {
                            pricePerNight = (price / nights).toFixed(2);
                        }
                        const priceData = {
                            id: '',
                            name: priceItemName,
                            totalNight: pricePerNight || price,
                            breakfast: priceItemName.toLowerCase().match(breakfastText) ? 1 : 0,
                            refundable: refundableBlock.toLowerCase().match(refundableText) ? 1 : 0,
                        };
                        roomData.prices.push(priceData);
                    });
                    roomDetailsArray.push(roomData);
                }
            });
        }
        return roomDetailsArray;
    };
    /**
       * Implements **bookingId**.
       *
       * @memberOf module:bs_8
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        // example URL: https://robinhood.backhotelengine.com/bookcore/your-booking/confirmation/crm30wum01/?lang=en&s=ba9242f15dc1846a429045894b6f9c15
        const widgetData = {};
        let tmp;
        $ = window.jQuery;
        const isBookingCancelled = thn.data.accountUserId === 1032170 && dataLayer && !thn.dataLayerHelper.get('transactionState')?.includes('CONF');
        if (isBookingCancelled) {
            this.logger.debug('This is not a confirmed booking');
            widgetData.set = false;
            return widgetData;
        }
        const hotelsData = {
            1034463: {
                pollentia: { hotelId: 1065725, propertyId: 1000356, hotelName: 'pollentia' }, // PortBlue Club Pollentia
                lesivory: { hotelId: 1091485, propertyId: 1015938, hotelName: 'le sivory' }, // Le Sivory Punta Cana By Portblue Boutique
                laquinta: { hotelId: 1091486, propertyId: 1015939, hotelName: 'la quinta' }, // PortBlue La Quinta Hotel & Spa - Adults Only
                salgar: { hotelId: 1091487, propertyId: 1015940, hotelName: "s'algar" }, // PortBlue S'Algar Hotel
                sanluis: { hotelId: 1091488, propertyId: 1015941, hotelName: 'san luis' }, // PortBlue San Luis
                rafalet: { hotelId: 1091490, propertyId: 1015942, hotelName: 'rafalet' }, // PortBlue Rafalet
                palmeras: { hotelId: 1091489, propertyId: 1015943, hotelName: 'las palmeras' }, // PortBlue Las Palmeras
                spaciudadastorga: { hotelId: 1584461, propertyId: 1027742, hotelName: 'astorga' }, // Spa Ciudad de Astorga by PortBlue Boutique
            },
        };
        const userData = hotelsData[thn.data.accountUserId];
        if (userData) {
            let hotelCode = thn.dataLayerHelper.get('hotel_code') || thn.dataLayerHelper.get('hotelCode');
            // Try to find the hotel_code by the hotel_name
            if (!hotelCode) {
                const hotelName = ((document.querySelector('.roi-booking-certificate__property-info-value') || {}).textContent
                    || (document.querySelector('.roi-booking-certificate__voucher-receipt-text') || {}).textContent
                    || '').toLowerCase();
                if (hotelName) {
                    hotelCode = Object.keys(userData).filter(function (key) {
                        return hotelName.indexOf(userData[key].hotelName) >= 0;
                    });
                }
            }
            const propertyData = hotelCode && userData[hotelCode];
            if (propertyData) {
                // Override the property info for this booking (multi-hotel bookings)
                widgetData.hotelId = propertyData.hotelId;
                widgetData.propertyId = propertyData.propertyId;
            }
            else {
                // Property not found, so do not register the booking (it must be for a non-contracted hotel)
                widgetData.set = false;
                return widgetData;
            }
        }
        // bookingId
        const idMatch = window.location.pathname.match(/confirmation\/([^/]+)/);
        if (idMatch) {
            widgetData.bookingId = idMatch[1];
        }
        // price
        let price;
        const priceContainer = document.querySelector('[class*=_total-price-amount], [class*=_total-price-logged-amount], [class=contenedor-precio]');
        const priceLoggedContent = document.querySelector('.roi-booking-certificate__total-price-logged-content > span, .voucher__total-price-logged-amount');
        const totalReserva = document.getElementsByClassName('total-reserva');
        const precioTotal = document.getElementsByClassName('precio_total');
        const isNyxHotels = [1032142].includes(thn.data.accountUserId);
        // Try taking price from the datalayer
        if (dataLayer && thn.objectGet(dataLayer, 'purchase') && !isNyxHotels) {
            const shouldAddTax = [1034463, 1032353, 1032221, 1033870].includes(thn.data.accountUserId);
            const getTaxAmount = () => thn.objectGet(window.dataLayer, 'purchase')?.actionField?.tax || 0;
            price = thn.objectGet(dataLayer, 'purchase').actionField.revenue;
            widgetData.price = parseFloat(price);
            if (shouldAddTax) {
                widgetData.price += getTaxAmount();
            }
        }
        else if (priceContainer && priceContainer.getAttribute('data-price')) {
            price = priceContainer.getAttribute('data-price');
            widgetData.price = parseFloat(price);
            // Price above can be striked-out and replaced by price below if user is logged in
            if (priceLoggedContent) {
                price = priceLoggedContent.getAttribute('data-price');
                widgetData.price = parseFloat(price);
            }
        }
        else if (totalReserva.length > 0) {
            tmp = (totalReserva[0].innerText || totalReserva[0].textContent).substr((totalReserva[0].innerText || totalReserva[0].textContent).indexOf(':'));
            widgetData.price = thn.parseNumber(tmp);
        }
        else if (precioTotal.length > 0) {
            tmp = (precioTotal[0].innerText || precioTotal[0].textContent);
            widgetData.price = thn.parseNumber(tmp);
        }
        // Currency
        // preferred
        let currency = document.querySelector('.roi-booking-certificate__total-price-amount.contenedor-precio, .contenedor-precio');
        if (currency && currency.dataset && currency.dataset.currency) {
            widgetData.currency = currency.dataset.currency;
        }
        // fallback 1
        if (!widgetData.currency && dataLayer) {
            currency = dataLayer && thn.arrayGet(dataLayer, 'currencyCode');
            if (currency) {
                widgetData.currency = thn.getCurrencyCode(currency);
            }
        }
        // fallback 2
        if (!widgetData.currency && tmp) {
            currency = /^\D+|\D+$/.exec(tmp);
            if (currency) {
                widgetData.currency = thn.getCurrencyCode(currency[0].trim().substr(0, 3));
            }
        }
        // Price almost last resort: google_conversion_value
        const googleConversionValue = window.google_conversion_value;
        if (typeof widgetData.price === 'undefined' && typeof googleConversionValue === 'number') {
            widgetData.price = googleConversionValue;
        }
        // Currency almost last resort: google_conversion_currency
        if ((typeof widgetData.currency === 'undefined') || (widgetData.currency === '')) {
            widgetData.currency = window.google_conversion_currency || ctx.tmpSession.currency;
        }
        // Dates
        if ((document.getElementById('fromHTMLtestdiv') !== null)) {
            const table = document.getElementById('fromHTMLtestdiv').getElementsByTagName('table')[4];
            const dateBegin = (table.rows[1].cells[2].innerText || table.rows[1].cells[2].textContent);
            const dateEnd = (table.rows[1].cells[3].innerText || table.rows[1].cells[3].textContent);
            const f = new Date(`${dateBegin.substr(7, 4)}/${dateBegin.substr(4, 2)}/${dateBegin.substr(1, 2)}`);
            const t = new Date(`${dateEnd.substr(7, 4)}/${dateEnd.substr(4, 2)}/${dateEnd.substr(1, 2)}`);
            widgetData.dateBegin = (`${f.getFullYear()}/${f.getMonth() + 1}/${f.getDate()}`);
            widgetData.dateEnd = (`${t.getFullYear()}/${t.getMonth() + 1}/${t.getDate()}`);
        }
        else if (((typeof $ !== 'undefined') && ($.isFunction($))) && ($('#bono-detalle-habitaciones').length > 0)) {
            widgetData.dateBegin = $('#bono-detalle-habitaciones tr:eq(1) td:eq(1)').text();
            widgetData.dateBegin = `${widgetData.dateBegin.substr(6, 4)}/${widgetData.dateBegin.substr(3, 2)}/${widgetData.dateBegin.substr(0, 2)}`;
            widgetData.dateEnd = $('#bono-detalle-habitaciones tr:eq(1) td:eq(2)').text();
            widgetData.dateEnd = `${widgetData.dateEnd.substr(6, 4)}/${widgetData.dateEnd.substr(3, 2)}/${widgetData.dateEnd.substr(0, 2)}`;
        }
        else if (document.querySelector('.voucher__room-info-checkin ') && document.querySelector('.voucher__room-info-checkout')) {
            const dateBeginRaw = document.querySelector('.voucher__room-info-checkin .voucher__room-info-value')?.textContent;
            const dateEndRaw = document.querySelector('.voucher__room-info-checkout .voucher__room-info-value').textContent;
            const dateBeginParsed = dateBeginRaw?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            const dateEndParsed = dateEndRaw?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            if (dateBeginParsed && dateEndParsed) {
                widgetData.dateBegin = dateBeginParsed;
                widgetData.dateEnd = dateEndParsed;
            }
        }
        else if (document.getElementById('id_entrada') !== null) {
            const dateBeginEl = document.querySelector('.js-roicalendar-checkin-full-date[value]');
            if (dateBeginEl) {
                widgetData.dateBegin = dateBeginEl.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else {
                widgetData.dateBegin = document.getElementById('id_entrada').value;
                widgetData.dateBegin = `${widgetData.dateBegin.substr(6, 4)}/${widgetData.dateBegin.substr(3, 2)}/${widgetData.dateBegin.substr(0, 2)}`;
            }
            const dateEndEl = document.querySelector('.js-roicalendar-checkout-full-date[value]');
            if (dateEndEl) {
                widgetData.dateEnd = dateEndEl.value.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else {
                widgetData.dateEnd = document.getElementById('id_salida').value;
                widgetData.dateEnd = `${widgetData.dateEnd.substr(6, 4)}/${widgetData.dateEnd.substr(3, 2)}/${widgetData.dateEnd.substr(0, 2)}`;
            }
        }
        else if (document.getElementById('bono-detalle-habitaciones')) {
            const table = document.getElementById('bono-detalle-habitaciones');
            const dateBegin = (table.rows[1].cells[1].innerText || table.rows[1].cells[1].textContent);
            const dateEnd = (table.rows[1].cells[2].innerText || table.rows[1].cells[2].textContent);
            const f = new Date(`${dateBegin.substr(6, 4)}/${dateBegin.substr(3, 2)}/${dateBegin.substr(0, 2)}`);
            const t = new Date(`${dateEnd.substr(6, 4)}/${dateEnd.substr(3, 2)}/${dateEnd.substr(0, 2)}`);
            widgetData.dateBegin = (`${f.getFullYear()}/${f.getMonth() + 1}/${f.getDate()}`);
            widgetData.dateEnd = (`${t.getFullYear()}/${t.getMonth() + 1}/${t.getDate()}`);
        }
        else {
            const dateBegin = (document.querySelector('[class*=room-info-checkin] span:nth-child(2)') || {}).textContent;
            const dateEnd = (document.querySelector('[class*=room-info-checkout] span:nth-child(2)') || {}).textContent;
            widgetData.dateBegin = dateBegin && dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            widgetData.dateEnd = dateEnd && dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
        }
        // This is a cancellation
        if (document.getElementsByClassName('cancelada').length) {
            widgetData.set = false;
        }
        // Get occupancy
        // Extract occupancy for each room booked
        const occupancies = [...document.querySelectorAll('.voucher__room-info-occupancy .voucher__room-info-value')].map((el) => {
            const occupantsTextSplitted = el.textContent.split('+');
            const roomAdults = occupantsTextSplitted.length > 0 && thn.parseNumber(occupantsTextSplitted[0]);
            const roomChildren = (occupantsTextSplitted.length > 1 && thn.parseNumber(occupantsTextSplitted[1])) || 0;
            // early exit (set as false to be filter out)
            if (!roomAdults) {
                return false;
            }
            return {
                adults: roomAdults,
                children: roomChildren,
            };
        }).filter(Boolean);
        // Sum of occupancies
        const occupancy = occupancies.reduce((a, b) => ({
            adults: a.adults + b.adults,
            children: a.children + b.children,
        }), { adults: 0, children: 0 });
        if (!thn.empty(occupancy) && !thn.empty(occupancy.adults)) {
            widgetData.adults = occupancy.adults;
            widgetData.children = occupancy.children;
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        // Promocode
        const promocode = (dataLayer && (thn.objectGet(dataLayer, 'actionField') || {}).coupon)
            || (document.querySelector('#js-promo_admin') || {}).textContent
            || ((document.querySelector('[class*=promocode-text]') || {}).textContent || '').split(': ')[1];
        // Inherited promo codes are affecting Oraculo
        const usersWithOraculoPromocode = [1037601].includes(thn.data.accountUserId);
        if (thn.empty(promocode) && usersWithOraculoPromocode) {
            widgetData.promocode = '';
        }
        if (promocode) {
            widgetData.promocode = promocode;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
